<template>
  <div class="container">
    <!-- <base-card :title="$t('menu.appointment-info')">
      <labeled-text label="Motivo de la consulta" text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."></labeled-text>
      <labeled-text label="Síntoma o enfermedad" text="Dolor de cabeza"></labeled-text>
    </base-card>
    <base-card :title="$t('menu.appointment-info')">
      <labeled-text label="Motivo de la consulta" text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."></labeled-text>
    </base-card>
    <base-card :title="$t('menu.appointment-info')">
      Motivo de la consulta
      <br>
      ttatatata
    </base-card>
    <clinic-history></clinic-history> -->
    <div class="range-slider">
      <input type="range" value="5" class="health-slider medium hidden-thumb" @change="updateColors" :disabled="hidden" list="tickmarks">
      <div class="ticks">
        <div>Muy mal</div>
        <div>Muy bien</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'base-card': () => import('@/components/base/ui/BaseCard.vue'),
    'labeled-text': () => import('@/components/base/ui/LabeledText.vue'),
    'clinic-history': () => import('@/components/shared/ClinicHistory.vue')
  },
  data () {
    return {
      hidden: false,
      currentClassColor: 'medium'
    }
  },
  methods: {
    updateColors (e) {
      if (e.target.classList.contains('hidden-thumb')) {
        return
      }
      var color = e.target.id.toString().indexOf('stress') > -1 ? (e.target.value < 4 ? 'high' : (e.target.value < 8 ? 'medium' : 'low')) : (e.target.value < 4 ? 'low' : (e.target.value < 8 ? 'medium' : 'high'))
      // Apply class to event element
      e.target.classList.remove(this.currentClassColor)
      this.currentClassColor = color
      e.target.classList.add(color)
    }
  }
}
</script>

<style lang="less">
.container {
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.range-slider {
  position: relative;
  width: 100%;
  .ticks {
    div {
      display: inline-block;
      position: absolute;

      &:first-child {
        left: 0;
      }
      &:last-child {
        right: 0;
      }
    }
  }
}

@mediumColor: #fcdf4a;
@lowColor: #B1324E;
@highColor: #95B665;

.health-colors() {
  &.high {
    background-color: @highColor;
    color: @highColor;
  }
  &.medium {
    background-color: @mediumColor;
    color: @mediumColor;
  }
  &.low {
    background-color: @lowColor;
    color: @lowColor;
  }
}

.health-colors(@pseudoSelector, @pre: ~'') {
  &.high@{pre}@{pseudoSelector} {
    background-color: @highColor;
    color: @highColor;
  }
  &.medium@{pre}@{pseudoSelector} {
    background-color: @mediumColor;
    color: @mediumColor;
  }
  &.low@{pre}@{pseudoSelector} {
    background-color: @lowColor;
    color: @lowColor;
  }
}

.health-colors-shadow(@pseudoSelector, @pre: ~'') {
  &.high@{pre}@{pseudoSelector} {
    box-shadow: -100px 0 0 100px @highColor;
  }
  &.medium@{pre}@{pseudoSelector} {
    box-shadow: -100px 0 0 100px @mediumColor;
  }
  &.low@{pre}@{pseudoSelector} {
    box-shadow: -100px 0 0 100px @lowColor;
  }
}

/*Chrome*/
@media screen and (-webkit-min-device-pixel-ratio:0) {
    input[type='range'] {
      width: 100%;
      overflow: hidden;
      background-color: #E4E4E4;
      -webkit-appearance: none;
      border-radius: 15px;
      .health-colors-shadow(-webkit-slider-thumb, ~'::');

      .health-colors-shadow(-webkit-slider-runnable-track, ~'::');
      /* .health-colors-shadow(-moz-range-thumb, ~'::'); */
      
      // FF
      .health-colors(-moz-range-progress, ~'::');
      .health-colors(-moz-range-track, ~'::');

      // IE
      .health-colors(-ms-fill-lower, ~'::');
      .health-colors(-ms-fill-upper, ~'::');
    }
    
    input[type='range'] {
      border-radius: 15px;
      -webkit-appearance: none;
    }
    
    input[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 12px;
      width: 12px;
      border-radius: 30px;
      cursor: pointer;
      /* border: 20px solid #2A5172 !important; */
      /* border-top-left-radius: 30px;
      border-bottom-left-radius: 30px; */
/*       width: 10px;
      height: 10px;
      cursor: ew-resize; */
      background: #2A5172;
    }

    input[type='range']&.hidden-thumb {
      .health-colors(-webkit-slider-thumb, ~'::');
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/testing/BaseCardTesting.vue